import { apiCall } from './gqlClient';

const GETSUBSERVICES_QUERY = `
  query getSubServices($serviceId: Int!) {
    getSubServices(serviceId: $serviceId)
    {
      id
			serviceId
			name
			description
			startTime
			endTime
			duration
			capacity
			price
			orderIndex
			active
			published
			resources
			providerId
			isDateAlwaysAvailable
			isTimeAlwaysAvailable
			reservationsCounter
			locationType
			defaultTimeSlotStep
			customerId
			materialResource
			preparationTime
			credits
			externalProvider
      ...fragments
    }
  }`;

export const getSubServicesApiCall = async ({serviceId}, fragments = null) => apiCall({ query: GETSUBSERVICES_QUERY, variables: {serviceId}, fragments });

const GETPUBLICSUBSERVICES_QUERY = `
  query getPublicSubServices($serviceId: Int!, $deal: Boolean) {
    getPublicSubServices(serviceId: $serviceId, deal: $deal)
    {
      id
			serviceId
			name
			description
			startTime
			endTime
			duration
			capacity
			price
			orderIndex
			active
			published
			resources
			providerId
			isDateAlwaysAvailable
			isTimeAlwaysAvailable
			reservationsCounter
			locationType
			defaultTimeSlotStep
			customerId
			materialResource
			preparationTime
			credits
			externalProvider
      ...fragments
    }
  }`;

export const getPublicSubServicesApiCall = async ({serviceId, deal}, fragments = null) => apiCall({ query: GETPUBLICSUBSERVICES_QUERY, variables: {serviceId, deal}, fragments });

const GETSUBSERVICESFORBOOKING_QUERY = `
  query getSubservicesForBooking($providerId: Int) {
    getSubservicesForBooking(providerId: $providerId)
    {
      id
			name
			serviceType
			isAlwaysAvailable
      ...fragments
    }
  }`;

export const getSubservicesForBookingApiCall = async ({providerId}, fragments = null) => apiCall({ query: GETSUBSERVICESFORBOOKING_QUERY, variables: {providerId}, fragments });

const GETALLSUBSERVICES_QUERY = `
  query getAllSubservices($serviceId: Int!) {
    getAllSubservices(serviceId: $serviceId)
    {
      id
			serviceId
			name
			description
			startTime
			endTime
			duration
			capacity
			price
			orderIndex
			active
			published
			resources
			providerId
			isDateAlwaysAvailable
			isTimeAlwaysAvailable
			reservationsCounter
			locationType
			defaultTimeSlotStep
			customerId
			materialResource
			preparationTime
			credits
			externalProvider
      ...fragments
    }
  }`;

export const getAllSubservicesApiCall = async ({serviceId}, fragments = null) => apiCall({ query: GETALLSUBSERVICES_QUERY, variables: {serviceId}, fragments });

const GETALLEVENARCHIVEDSUBSERVICES_QUERY = `
  query getAllEvenArchivedSubservices($serviceId: Int!) {
    getAllEvenArchivedSubservices(serviceId: $serviceId)
    {
      id
			serviceId
			name
			description
			startTime
			endTime
			duration
			capacity
			price
			orderIndex
			active
			published
			resources
			providerId
			isDateAlwaysAvailable
			isTimeAlwaysAvailable
			reservationsCounter
			locationType
			defaultTimeSlotStep
			customerId
			materialResource
			preparationTime
			credits
			externalProvider
      ...fragments
    }
  }`;

export const getAllEvenArchivedSubservicesApiCall = async ({serviceId}, fragments = null) => apiCall({ query: GETALLEVENARCHIVEDSUBSERVICES_QUERY, variables: {serviceId}, fragments });

const GETPROVIDERALLSUBSERVICES_QUERY = `
  query getProviderAllSubservices($serviceId: Int!) {
    getProviderAllSubservices(serviceId: $serviceId)
    {
      id
			serviceId
			name
			description
			startTime
			endTime
			duration
			capacity
			price
			orderIndex
			active
			published
			resources
			providerId
			isDateAlwaysAvailable
			isTimeAlwaysAvailable
			reservationsCounter
			locationType
			defaultTimeSlotStep
			customerId
			materialResource
			preparationTime
			credits
			externalProvider
      ...fragments
    }
  }`;

export const getProviderAllSubservicesApiCall = async ({serviceId}, fragments = null) => apiCall({ query: GETPROVIDERALLSUBSERVICES_QUERY, variables: {serviceId}, fragments });

const SAVESUBSERVICE_QUERY = `
  mutation saveSubService($request: SubServiceCreateInput!) {
    saveSubService(request: $request)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const saveSubServiceApiCall = async ({request}, fragments = null) => apiCall({ query: SAVESUBSERVICE_QUERY, variables: {request}, fragments });

const REORDERSUBSERVICES_QUERY = `
  mutation reorderSubServices($oldPosition: Int!, $newPosition: Int!) {
    reorderSubServices(oldPosition: $oldPosition, newPosition: $newPosition)
  }`;

export const reorderSubServicesApiCall = async ({oldPosition, newPosition}, ) => apiCall({ query: REORDERSUBSERVICES_QUERY, variables: {oldPosition, newPosition}});

const TOGGLESUBSERVICESTATUS_QUERY = `
  mutation toggleSubServiceStatus($id: Int!, $isActive: Boolean!, $serviceId: Int!) {
    toggleSubServiceStatus(id: $id, isActive: $isActive, serviceId: $serviceId)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const toggleSubServiceStatusApiCall = async ({id, isActive, serviceId}, fragments = null) => apiCall({ query: TOGGLESUBSERVICESTATUS_QUERY, variables: {id, isActive, serviceId}, fragments });

const DELETESUBSERVICE_QUERY = `
  mutation deleteSubService($id: Int!) {
    deleteSubService(id: $id)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const deleteSubServiceApiCall = async ({id}, fragments = null) => apiCall({ query: DELETESUBSERVICE_QUERY, variables: {id}, fragments });

const RESTORESUBSERVICE_QUERY = `
  mutation restoreSubservice($id: Int!) {
    restoreSubservice(id: $id)
  }`;

export const restoreSubserviceApiCall = async ({id}, ) => apiCall({ query: RESTORESUBSERVICE_QUERY, variables: {id}});

const SAVESERVICEWITHSUBSERVICE_QUERY = `
  mutation saveServiceWithSubService($request: ServicePlusSubServiceCreateInput!) {
    saveServiceWithSubService(request: $request)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const saveServiceWithSubServiceApiCall = async ({request}, fragments = null) => apiCall({ query: SAVESERVICEWITHSUBSERVICE_QUERY, variables: {request}, fragments });
